// extracted by mini-css-extract-plugin
export default {"addButton":"LabelsStep_addButton__vxcSF","droppableHack":"LabelsStep_droppableHack__deQ72","items":"LabelsStep_items__cZWCM"};